#import "./flexibleRichtext.graphql"
#import "./flexibleImage.graphql"
#import "./flexibleVideo.graphql"
#import "./flexibleAccordion.graphql"
#import "./flexibleButton.graphql"
#import "./flexibleDownload.graphql"
#import "./flexibleBigLinks.graphql"
#import "./flexibleTeamMembers.graphql"
#import "./flexibleQuote.graphql"
#import "./flexibleHelpCards.graphql"

#import "./flexibleSubsidies.graphql"
#import "./flexibleBigAccordion.graphql"
#import "./flexibleDeadlines.graphql"

#import "./flexiblePostCards.graphql"
#import "./flexiblePostCardsByTags.graphql"
#import "./flexiblePostCardsManualSelect.graphql"

#import "./flexiblePostsFeaturedManualSelect.graphql"
#import "./flexiblePostsFeaturedLatest.graphql"
#import "./flexiblePostsFeaturedByTags.graphql"

#import "./flexiblePostsSliderManualSelect.graphql"
#import "./flexiblePostsSliderLatest.graphql"
#import "./flexiblePostsSliderByTags.graphql"

#import "./flexibleTypeformEmbed.graphql"
#import "./flexibleAnchor.graphql"

fragment flexibleSections on flexibleSections_NeoField {
    __typename
    ... flexibleRichtext
    ... flexibleImage
    ... flexibleVideo
    ... flexibleAccordion
    ... flexibleButton
    ... flexibleDownload
    ... flexibleBigLinks
    ... flexibleTeamMembers
    ... flexibleQuote
    ... flexibleHelpCards
    ... flexibleSubsidies
    ... flexibleBigAccordion
    ... flexibleDeadlines

    ... flexiblePostCards
    ... flexiblePostCardsByTags
    ... flexiblePostCardsManualSelect

    ... flexiblePostsFeaturedManualSelect
    ... flexiblePostsFeaturedLatest
    ... flexiblePostsFeaturedByTags

    ... flexiblePostsSliderManualSelect
    ... flexiblePostsSliderLatest
    ... flexiblePostsSliderByTags

    ... flexibleTypeformEmbed

    ... flexibleAnchor
}
